import React, { useState, useEffect, useRef } from "react";
// import "../../../node_modules/react-progress-button/react-progress-button.css"
import InvoiceTemplate from "../Home/InvoiceTemp";
import { useSnackbar } from "react-simple-snackbar";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { initialState } from "../../initialState";
import { getInvoice, updateInvoice, markInvoiceForPrint } from "../../actions/invoiceActions";
import { getAllItems } from "../../actions/itemActions";
import { fetchPrinterLocation, rePrintInvoice, generateHtmlTemplet } from "../../api";
import { toCommas } from "../../utils/utils";
import styles from "./InvoiceDetails.module.css";
import currencies from "../../currencies.json";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import Spinner from "../Spinner/Spinner";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import ProgressButton from "react-progress-button";
import axios from "axios";
import { saveAs } from "file-saver";
import Modal from "../Payments/Modal";
import PrintIcon from "@material-ui/icons/Print";
import {
  useMediaQuery,
  useTheme,
  createTheme,
  ThemeProvider,
} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { IconButton } from "@material-ui/core";
import InvoicePreview from "./invoicePreview";
import ThermalInvoice from "./ThermalInvoice";
import PaymentHistory from "./PaymentHistory";

const InvoiceDetails = () => {
  const location = useLocation();
  const [state, setState] = useState(0);
  const [invoiceData, setInvoiceData] = useState(initialState);
  const [rates, setRates] = useState(0);
  const [vat, setVat] = useState(0);
  const [currency, setCurrency] = useState(currencies[1].value);
  const [subTotal, setSubTotal] = useState(0);
  const [total, setTotal] = useState(0);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [client, setClient] = useState([]);
  // const [supplier, setSupplier] = useState([]);
  const [signatureDataUrl, setSignatureDataUrl] = useState(null);
  const [type, setType] = React.useState("");
  const [status, setStatus] = useState("");
  const [company, setCompany] = useState({});
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { id } = useParams();
  // console.log("id", id);
  const { invoice } = useSelector((state) => state.invoices);
  // console.log(invoice);
  const items = useSelector((state) => state.items.items);
  const [isTaxCopy, setIsTaxCopy] = useState(false); // true for Tax Copy, false for Customer Copy

  const dispatch = useDispatch();
  const history = useHistory();
  const navigate = (to) => {
    if (typeof window !== "undefined" && window.location) {
      window.location.href = to;
    }
  };
  const [sendStatus, setSendStatus] = useState(null);
  const [downloadStatus, setDownloadStatus] = useState(null);
  const [printStatus, setPrintStatus] = useState(null);
  // console.log("IsPrintBillFlag",invoice.isPrintBill)
  // eslint-disable-next-line
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const user = JSON.parse(localStorage.getItem("profile"));
  const [printInvoice, setPrintInvoice] = useState(false);
  const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
      "& > *": {
        margin: theme.spacing(1),
      },
    },
    large: {
      width: theme.spacing(12),
      height: theme.spacing(12),
    },
    table: {
      minWidth: 650,
    },

    headerContainer: {
      // display: 'flex'
      paddingTop: theme.spacing(1),
      paddingLeft: theme.spacing(5),
      paddingRight: theme.spacing(1),
      backgroundColor: "#f2f2f2",
      borderRadius: "10px 10px 0px 0px",
    },
  }));

  const classes = useStyles();

  useEffect(() => {
    dispatch(getInvoice(id));
  }, [id, dispatch, location]);

  useEffect(() => {
    if (invoice) {
      //Automatically set the default invoice values as the ones in the invoice to be updated
      setInvoiceData(invoice);
      setRates(invoice.rates);
      setClient(invoice.client);
      // setSupplier(invoice.supplier);
      setType(invoice.type);
      setStatus(invoice.status);
      setSelectedDate(invoice.dueDate);
      setVat(invoice.vat);
      setCurrency(invoice.currency);
      setSubTotal(invoice.subTotal);
      setTotal(invoice.total);
      setCompany(user.userProfile);
      setSignatureDataUrl(invoice.signatureDataUrl);
    }
  }, [invoice]);
  useEffect(() => {
    dispatch(
      // getItemsByUser({ search: user?.result._id || user?.result?.googleId })
      getAllItems()
    );
    // eslint-disable-next-line
  }, [dispatch]);

  //Get the total amount paid
  let totalAmountReceived = 0;
  for (var i = 0; i < invoice?.paymentRecords?.length; i++) {
    totalAmountReceived += Number(invoice?.paymentRecords[i]?.amountPaid);
  }

  const editInvoice = (id) => {
    history.push(`/edit/invoice/${id}`);
  };

  const createAndPrintPdf = () => {
    setPrintStatus("loading");
    const encodedInvoiceNumber = encodeURIComponent(
      String(invoice?.invoiceNumber || "")
    );
    axios
      .post(
        `${process.env.REACT_APP_API}/create-pdf/${encodedInvoiceNumber}`,
        {
          name: invoice.client.name,
          address: invoice.client.address,
          phone: invoice.client.phone,
          email: invoice.client.email,
          dueDate: invoice.client.dueDate,
          // supplierName: invoice.supplier.name,
          // supplierAddress: invoice.supplier.address,
          // supplierPhone: invoice.supplier.phone,
          // supplierEmail: invoice.supplier.email,
          signatureDataUrl: invoice.signatureDataUrl,
          date: invoice.createdAt,
          id: invoice.invoiceNumber,
          notes: invoice.notes,
          subTotal: toCommas(invoice.subTotal),
          total: toCommas(invoice.total),
          type: invoice.type,
          vat: invoice.vat,
          items: invoice.items,
          status: invoice.status,
          totalAmountReceived: toCommas(totalAmountReceived),
          balanceDue: toCommas(total - totalAmountReceived),
          company: company,
        }
      )
      .then(() =>
        axios.get(
          `${process.env.REACT_APP_API}/fetch-pdf/${encodedInvoiceNumber}`,
          {
            responseType: "blob",
          }
        )
      )
      .then((res) => {
        const pdfBlob = new Blob([res.data], { type: "application/pdf" });
        const downloadUrl = window.URL.createObjectURL(pdfBlob);
        setPrintStatus("success");

        // Open a new browser window for printing the PDF
        const printWindow = window.open(downloadUrl, "_blank");

        // Wait for the PDF to load, then trigger printing
        printWindow.onload = () => {
          printWindow.print();
          // You can close the print window automatically if needed
          // printWindow.close();
        };
      });
  };
  const [pdfUrl, setPdfUrl] = useState(null);

  // Effect to open PDF when URL is available
  useEffect(() => {
    if (pdfUrl) {
      window.open(pdfUrl, "_blank");
      setPdfUrl(null); // Reset URL after opening
    }
  }, [pdfUrl]);

  // Function to detect if the system is Windows using navigator.userAgent
  const isWindows = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    return userAgent.includes("windows");
  };

  // const createAndDownloadPdf = () => {
  //   setDownloadStatus("loading");

  //   axios
  //     .post(
  //       `${process.env.REACT_APP_API}/create-pdf/${invoice.invoiceNumber}`,
  //       {
  //         name: invoice.client?.name,
  //         address: invoice.client?.address,
  //         phone: invoice.client?.phone,
  //         email: invoice.client?.email,
  //         dueDate: invoice.client?.dueDate,
  //         signatureDataUrl: invoice?.signatureDataUrl,
  //         date: invoice.createdAt,
  //         id: invoice.invoiceNumber,
  //         notes: invoice.notes,
  //         subTotal: toCommas(invoice.subTotal),
  //         total: toCommas(invoice.total),
  //         receivedAmount: toCommas(invoice.receivedAmount),
  //         change: toCommas(invoice.change),
  //         paymentMode: invoice.paymentMode,
  //         type: invoice.type,
  //         vat: invoice.vat,
  //         discount: invoice.discount,
  //         items: invoice.items,
  //         status: invoice.status,
  //         totalAmountReceived: toCommas(totalAmountReceived),
  //         balanceDue: toCommas(total - totalAmountReceived),
  //         company: company,
  //       }
  //     )
  //     .then(() =>
  //       axios.get(
  //         `${process.env.REACT_APP_API}/fetch-pdf/${invoice.invoiceNumber}`,
  //         {
  //           responseType: "blob",
  //         }
  //       )
  //     )
  //     .then((res) => {
  //       const pdfBlob = new Blob([res.data], { type: "application/pdf" });

  //       // Save PDF locally
  //       saveAs(pdfBlob, `order${invoice.invoiceNumber}.pdf`);

  //       // Set the URL to trigger useEffect
  //       const downloadUrl = `${process.env.REACT_APP_URL}/files/Exported-order/order${invoice.invoiceNumber}.pdf`;
  //       setPdfUrl(downloadUrl);

  //       setDownloadStatus("success");
  //     });
  // };
  //SEND PDF INVOICE VIA EMAIL

  const createAndDownloadPdf = async () => {
    setDownloadStatus("loading");

    try {
      if (!invoice?.invoiceNumber) {
        throw new Error("Missing required invoice data (invoiceNumber).");
      }
      const rawInvoiceNumber = String(invoice.invoiceNumber);
      const encodedInvoiceNumber = encodeURIComponent(rawInvoiceNumber);
      const safeInvoiceFileName = rawInvoiceNumber.replace(/[\\/:*?"<>|]/g, "-");

      const response = await axios.post(
        `${process.env.REACT_APP_API}/create-pdf/${encodedInvoiceNumber}`,
        {
          name: invoice.client?.name,
          address: invoice.client?.address,
          phone: invoice.client?.phone,
          email: invoice.client?.email,
          dueDate: invoice.client?.dueDate,
          signatureDataUrl: invoice?.signatureDataUrl,
          date: invoice.createdAt,
          id: invoice.invoiceNumber,
          notes: invoice.notes,
          subTotal: toCommas(invoice.subTotal),
          total: toCommas(invoice.total),
          receivedAmount: toCommas(invoice.receivedAmount),
          change: toCommas(invoice.change),
          paymentMode: invoice.paymentMode,
          type: invoice.type,
          vat: invoice.vat,
          discount: invoice.discount,
          items: invoice.items,
          status: invoice.status,
          totalAmountReceived: toCommas(totalAmountReceived),
          balanceDue: toCommas(total - totalAmountReceived),
          company: company,
        }
      );
      console.log(items);

      if (response.status !== 200) {
        throw new Error("Failed to create PDF on the server.");
      }

      const res = await axios.get(
        `${process.env.REACT_APP_API}/fetch-pdf/${encodedInvoiceNumber}`,
        { responseType: "blob" }
      );

      const pdfBlob = new Blob([res.data], { type: "application/pdf" });
      saveAs(pdfBlob, `invoice${safeInvoiceFileName}.pdf`);

      setDownloadStatus("success");
      openSnackbar("PDF downloaded successfully!");
    } catch (error) {
      console.error("Error in createAndDownloadPdf:", error.message || error);
      setDownloadStatus("error");
      openSnackbar(
        `Failed to download PDF: ${error.message || "Unknown error"}`
      );
    }
  };

  // useEffect(() => {
  //   if(invoice){
  //     axios
  //     .post(`${process.env.REACT_APP_API}/send-pdf-whatsapp`, {
  //       name: invoice.client?.name,
  //       address: invoice.client?.address,
  //       phone: invoice.client?.phone,
  //       email: invoice.client?.email,
  //       dueDate: invoice.client?.dueDate,
  //       // supplierName: invoice.supplier.name,
  //       // supplierAddress: invoice.supplier.address,
  //       // supplierPhone: invoice.supplier.phone,
  //       // supplierEmail: invoice.supplier.email,
  //       signatureDataUrl: invoice.signatureDataUrl,
  //       date: invoice.createdAt,
  //       id: invoice.invoiceNumber,
  //       notes: invoice.notes,
  //       subTotal: toCommas(invoice.subTotal),
  //       total: toCommas(invoice.total),
  //       receivedAmount: toCommas(invoice.receivedAmount),
  //       change: toCommas(invoice.change),
  //       paymentMode: invoice.paymentMode,
  //       type: invoice.type,
  //       vat: invoice.vat,
  //       discount: invoice.discount,
  //       items: invoice.items.map((cartItem) => ({
  //         item: cartItem._id, // Extract _id
  //         quantity: cartItem.quantity, // Extract quantity
  //       })),
  //       status: invoice.status,
  //       totalAmountReceived: toCommas(totalAmountReceived),
  //       balanceDue: toCommas(total - totalAmountReceived),
  //       company: company,
  //     })
  //     .then(() => {
  //       setSendStatus("success");
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setSendStatus("error");
  //     });
  //   }

  // }, [invoice]);

  // const sendPdf = (e) => {
  //   e.preventDefault();
  //   setSendStatus("loading");
  //   setLoading(true);

  //   console.log("Client Phone Number", invoice.client.phone);

  //   const whatsappURL = `https://wa.me/${invoice.client.phone}?text=${process.env.REACT_APP_URL}/files/Exported-order/order${invoice.invoiceNumber}.pdf`;

  //   window.open(whatsappURL, "_blank");

  //   // window.open(res.data.whatsappURL, "_blank");

  //   // .then(() => console.log("invoice sent successfully"))

  //   setSendStatus("success");
  //   setLoading(false);
  // };

  const sendPdf = async (e) => {
    e.preventDefault();
    setSendStatus("loading");
    setLoading(true);
    console.log(invoice);

    try {
      if (!invoice?.invoiceNumber) {
        throw new Error("Missing required invoice data (invoiceNumber).");
      }
      const rawInvoiceNumber = String(invoice.invoiceNumber);
      const encodedInvoiceNumber = encodeURIComponent(rawInvoiceNumber);
      const safeInvoiceFileName = rawInvoiceNumber.replace(/[\\/:*?"<>|]/g, "-");

      const response = await axios.post(
        `${process.env.REACT_APP_API}/create-pdf/${encodedInvoiceNumber}`,
        {
          name: invoice.client?.name,
          address: invoice.client?.address,
          phone: invoice.client?.phone,
          email: invoice.client?.email,
          dueDate: invoice.client?.dueDate,
          signatureDataUrl: invoice?.signatureDataUrl,
          date: invoice.createdAt,
          id: invoice.invoiceNumber,
          notes: invoice.notes,
          subTotal: toCommas(invoice.subTotal),
          total: toCommas(invoice.total),
          receivedAmount: toCommas(invoice.receivedAmount),
          change: toCommas(invoice.change),
          paymentMode: invoice.paymentMode,
          type: invoice.type,
          vat: invoice.vat,
          discount: invoice.discount,
          items: invoice.items,
          status: invoice.status,
          totalAmountReceived: toCommas(totalAmountReceived),
          balanceDue: toCommas(total - totalAmountReceived),
          company: company,
        }
      );

      if (response.status !== 200) {
        throw new Error("Failed to create PDF on the server.");
      }

      const pdfUrl = `${process.env.REACT_APP_URL}/files/Exported-order/invoice${safeInvoiceFileName}.pdf`;
      const whatsappURL = `https://wa.me/${invoice.client?.phone}?text=${process.env.REACT_APP_URL}/files/Exported-order/invoice${safeInvoiceFileName}.pdf`;

      window.open(whatsappURL, "_blank");

      setSendStatus("success");
      openSnackbar("PDF sent successfully via WhatsApp!");
    } catch (error) {
      console.error("Error in sendPdf:", error.message || error);
      setSendStatus("error");
      openSnackbar(`Failed to send PDF: ${error.message || "Unknown error"}`);
    } finally {
      setLoading(false);
    }
  };

  const iconSize = {
    height: "18px",
    width: "18px",
    marginRight: "10px",
    color: "gray",
  };
  const [open, setOpen] = useState(false);

  function checkStatus() {
    return totalAmountReceived >= total
      ? "green"
      : status === "Partial"
      ? "#1976d2"
      : status === "Paid"
      ? "green"
      : status === "Unpaid"
      ? "red"
      : "red";
  }

  if (!invoice) {
    return <Spinner />;
  }

  const colorTheme = createTheme({
    palette: {
      primary: {
        main: "#ef7f1a",
      },
    },
  });
  const handleRadioChange = (isTax) => {
    setIsTaxCopy(isTax);
  };
  // const handleInvoiceReprint = async () => {
  //   try {
  //     // First, check if user has printer name assigned
  //     // const printerResponse = await fetchPrinterLocation(user?.userProfile?._id);

  //     // if (!printerResponse.data?.success || !printerResponse.data?.data?.printerLocation?.printerName) {
  //     //   openSnackbar("Please assign a printer name in settings first!");
  //     //   return;
  //     // }

  //     // const printerName = printerResponse.data.data.printerLocation.printerName;

  //     // Update the invoice with isPrintBill = true and latest printer name
  //     const updatedInvoice = {
  //       ...invoice,
  //       isPrintBill: true,
  //       // printerName: printerName
  //     };

  //       // If HTML template is empty, generate it from backend
  //       if (
  //         updatedInvoice.htmlTemplete === null || updatedInvoice.htmlTemplete.trim() === "") {
  //         const fileName = invoice._id || Date.now();

  //         const response = await rePrintInvoice(fileName, {
  //           invoice: updatedInvoice,
  //           userProfile: user?.userProfile || {},
  //         });

  //         console.log("✅ rePrintInvoice response:", response.data);

  //         if (response.data?.htmlTemplete) {
  //           updatedInvoice.htmlTemplete = response.data.htmlTemplete;
  //           console.log(updatedInvoice)
  //         }
  //       }

  //     // Update the invoice in the database
  //     await dispatch(updateInvoice(invoice._id, updatedInvoice));

  //     openSnackbar("Invoice marked for printing successfully!");
  //   } catch (e) {
  //     console.error("Update failed:", e?.message || e);
  //     openSnackbar("Update failed. Please try again.");
  //   }
  // };

  // const handleInvoiceReprint = async () => {
  //   try {
  //     if (!invoice?._id) {
  //       openSnackbar("Invalid invoice data. Please refresh and try again.");
  //       return;
  //     }

  //     const profilePrinterName =
  //       user?.userProfile?.printerLocation?.printerName?.trim() || "";

  //     if (!profilePrinterName) {
  //       openSnackbar("No printer configured for your profile. Please contact admin.");
  //       return;
  //     }

  //     const oldPrinterName = invoice?.printerName?.trim() || "(none)";
  //     console.log("[Reprint] Existing printer name:", oldPrinterName);
  //     console.log("[Reprint] Printer from profile:", profilePrinterName);

  //     const baseInvoice = { ...invoice };
  //     const printerUpdatedInvoice = {
  //       ...baseInvoice,
  //       printerName: profilePrinterName,
  //       isPrintBill: false,
  //       htmlTemplate:
  //         (baseInvoice.htmlTemplate || baseInvoice.htmlTemplete || "").trim(),
  //       htmlTemplete:
  //         (baseInvoice.htmlTemplete || baseInvoice.htmlTemplate || "").trim(),
  //     };

  //     await dispatch(updateInvoice(invoice._id, printerUpdatedInvoice));

  //     const existingHtml =
  //       printerUpdatedInvoice.htmlTemplate ||
  //       printerUpdatedInvoice.htmlTemplete ||
  //       "";
  //     let finalHtml = existingHtml;

  //     const isHtmlMissing = !finalHtml || finalHtml.trim() === "";

  //     if (isHtmlMissing) {
  //       const fileName = invoice._id || Date.now();

  //       console.log("🧾 Re-generating HTML template for invoice:", fileName);

  //       const response = await generateHtmlTemplet(fileName, {
  //         invoice: { ...printerUpdatedInvoice },
  //         userProfile: user?.userProfile || {},
  //       });

  //       console.log("✅ Generate HTML Templet response:", response.data);

  //       if (response?.data?.htmlTemplete) {
  //         finalHtml = response.data.htmlTemplete;
  //         console.log("✅ Updated invoice HTML template");
  //       } else {
  //         console.warn("⚠️ No HTML template returned from backend.");
  //       }
  //     }

  //     if (!finalHtml || finalHtml.trim() === "") {
  //       openSnackbar("Failed to generate invoice template. Please try again.");
  //       return;
  //     }

  //     const sanitizedHtml = finalHtml.trim();

  //     const finalInvoicePayload = {
  //       ...printerUpdatedInvoice,
  //       htmlTemplete: sanitizedHtml,
  //       htmlTemplate: sanitizedHtml,
  //       isPrintBill: false,
  //     };

  //     await dispatch(updateInvoice(invoice._id, finalInvoicePayload));

  //     try {
  //       await dispatch(markInvoiceForPrint(invoice._id));
  //     } catch (markErr) {
  //       console.error("❌ Failed to enable print flag:", markErr?.message || markErr);
  //       // openSnackbar("Failed to mark invoice for printing. Please try again.");
  //       console.log("Failed to mark invoice for printing. Please try again.");
  //       return;
  //     }

  //     openSnackbar("Invoice marked for printing successfully!");
  //   } catch (e) {
  //     console.error("❌ Update failed:", e?.message || e);
  //     openSnackbar("Update failed. Please try again.");
  //   }
  // };


  const handleInvoiceReprint = async () => {
    try {
      console.log("──────────────────────────────────────────");
      console.log(`[Reprint] Started for invoiceId: ${invoice?._id}`);
  
      if (!invoice?._id) {
        console.log("[Reprint] ❌ Invalid invoice data");
        openSnackbar("Invalid invoice data");
        return;
      }
  
      // Old printer
      const oldPrinter = invoice?.printerName?.trim() || "(none)";
      console.log("[Reprint] Existing printer name:", oldPrinter);
  
      // New printer
      const profilePrinter =
        user?.userProfile?.printerLocation?.printerName?.trim() || "";
      console.log("[Reprint] Printer from profile:", profilePrinter);
  
      if (!profilePrinter) {
        console.log("[Reprint] ❌ No printer configured for this user");
        openSnackbar("No printer configured for your profile");
        return;
      }
  
      let html =
        invoice.htmlTemplate || invoice.htmlTemplete || "";
  
      const missingHtml = !html || html.trim() === "";
      console.log("[Reprint] HTML missing?:", missingHtml);
      console.log("[Reprint] HTML existing size:", html?.length || 0);
  
      let updatedInvoice = { ...invoice };
  
      // --------------------------------------------------
      // 1) REGENERATE HTML TEMPLATE IF MISSING
      // --------------------------------------------------
      if (missingHtml) {
        console.log("[Reprint] Regenerating HTML template...");
  
        const fileName = invoice._id;
  
        const response = await generateHtmlTemplet(fileName, {
          invoice: updatedInvoice,
          userProfile: user?.userProfile || {},
        });
  
        html = response?.data?.htmlTemplate || "";
  
        console.log("[Reprint] Regenerated HTML size:", html?.length || 0);
  
        if (!html || html.trim() === "") {
          console.log("[Reprint] ❌ Regenerated HTML still empty");
          openSnackbar("Failed to regenerate invoice template");
          return;
        }
  
        updatedInvoice.htmlTemplate = html;
        updatedInvoice.htmlTemplete = html;
      } else {
        console.log("[Reprint] HTML already exists → no regeneration needed");
      }
  
      // --------------------------------------------------
      // 2) UPDATE PRINTER NAME + SAVE INVOICE
      // --------------------------------------------------
      console.log(
        `[Reprint] Updating invoice printer (old: ${oldPrinter}, new: ${profilePrinter})`
      );
  
      updatedInvoice.printerName = profilePrinter;
  
      await dispatch(updateInvoice(invoice._id, updatedInvoice));
  
      console.log("[Reprint] Invoice updated successfully");
  
      // --------------------------------------------------
      // 3) MARK INVOICE FOR PRINTING
      // --------------------------------------------------
      console.log("[Reprint] Setting isPrintBill=true & printStatus=pending");
  
      await dispatch(markInvoiceForPrint(invoice._id));
  
      console.log("[Reprint] ✔ Invoice marked for printing");
      console.log("──────────────────────────────────────────");
  
      openSnackbar("Invoice sent to printer successfully!");
  
    } catch (e) {
      console.log("[Reprint] ❌ Error:", e?.message || e);
      console.log("──────────────────────────────────────────");
      openSnackbar("Reprint failed. Try again.");
    }
  };
  

  return (
    <div className={styles.PageLayout}>
      <div
        className={styles.buttons}
        style={{
          display: "flex",
          flexDirection: isSmallScreen ? "column" : "row",
          gap: "10px",
        }}
      >
        {/* <div
          style={{
            display: "flex",
            flexDirection: isSmallScreen ? "column" : "row",
            alignItems: "center",
            gap: "10px",
            marginTop: "10px",
          }}
        >
          <label>
            <input
              type="radio"
              name="invoiceCopy"
              checked={isTaxCopy}
              onChange={() => handleRadioChange(true)}
            />
            Tax Copy
          </label>
          <label>
            <input
              type="radio"
              name="invoiceCopy"
              checked={!isTaxCopy}
              onChange={() => handleRadioChange(false)}
            />
            Customer Copy
          </label>
        </div> */}
        <div style={{ width: isSmallScreen ? "90%" : "auto" }}>
          {user?.result?.userType === "admin" && (
            <button
              className={styles.btn}
              onClick={() => editInvoice(invoiceData._id)}
            >
              <BorderColorIcon style={iconSize} />
              Edit Order
            </button>
          )}
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginRight: "10px",
          }}
        >
          <ProgressButton
            onClick={createAndDownloadPdf}
            state={downloadStatus}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              backgroundColor: "Transparent",
              color: "#000000",
              border: "none",
              borderRadius: "24px",
              padding: "8px",
              height: "40px",
              width: isSmallScreen ? "100%" : "10rem",
              marginTop: "7px",
              cursor: "pointer",
            }}
          >
            Download
          </ProgressButton>
          {invoice.paymentMode === "Credit" && (
            <button
              // disabled={status === 'Paid' ? true : false}
              className={styles.btn}
              onClick={() => setOpen((prev) => !prev)}
            >
              ₹ Record Payment
            </button>
          )}
          {/* <ProgressButton
            onClick={handleInvoiceReprint}
            state={printStatus}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              backgroundColor: "Transparent",
              color: "#000000",
              border: "none",
              borderRadius: "24px",
              padding: "8px",
              height: "40px",
              width: isSmallScreen ? "100%" : "10rem",
              marginTop: "7px",
              cursor: "pointer",
            }}
          >
           Reprint
          </ProgressButton> */}
          <IconButton aria-label="Re-Print" onClick={handleInvoiceReprint}>
            <PrintIcon />
          </IconButton>
          <ThemeProvider theme={colorTheme}>
            {loading ? (
              <CircularProgress />
            ) : (
              <img
                className={styles.wp}
                src="https://www.sharethis.com/wp-content/uploads/2017/05/WhatsApp.png"
                alt=""
                style={{ height: "3rem", width: "3rem", cursor: "pointer" }}
                onClick={sendPdf}
              />
            )}
          </ThemeProvider>
        </div>
      </div>
      {invoice?.paymentRecords.length !== 0 && (
        <PaymentHistory paymentRecords={invoiceData?.paymentRecords} />
      )}
      {/* {(invoice.isPrintBill || printInvoice ) && (
        <div style={{ position: "absolute", left: "-9999px", top: "-9999px" }}>
          <InvoiceTemplate invoice={invoice} />
        </div>
      )
      
      } */}

      {/* below for imin print for artweed */}

      {/* {printInvoice && (
        <div style={{ position: "absolute", left: "-9999px", top: "-9999px" }}>
          <InvoiceTemplate
            invoice={invoice}
            isTaxCopy={isTaxCopy}
            userProfile={user.userProfile}
          />
        </div>
      )} */}

      {/* below for thermal print for shrihari */}

      {/* {printInvoice && (
        <div style={{ position: "absolute", left: "-9999px", top: "-9999px" }}>
          <ThermalInvoice
            invoice={invoice}
            isTaxCopy={isTaxCopy}
            userProfile={user.userProfile}
          />
        </div>
      )} */}

      {/* below for  both print immin and thermal print */}

      {/* Frontend hidden window.print disabled: server-side printing will be used */}

      <Modal open={open} setOpen={setOpen} invoice={invoice} />
      <div className={styles.invoiceLayout}>
        <div>
          <InvoicePreview
            creditPayment={[total, totalAmountReceived]}
            userProfile={user.userProfile}
            invoice={invoice}
            isTaxCopy={isTaxCopy}
          />
        </div>
        {/* <div className={styles.summaryItem}>
          <p>Paid</p>
          <h4>
            {currency} {toCommas(totalAmountReceived)}
          </h4>
        </div>

        <div className={styles.summaryItem}>
          <p>Balance</p>
          <h4 style={{ color: "black", fontSize: "18px", lineHeight: "8px" }}>
            {currency} {toCommas((total - totalAmountReceived)==0? "0" : (total - totalAmountReceived))}
          </h4>
        </div> */}
      </div>
    </div>
  );
};

export default InvoiceDetails;
